import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/encyclopedia?q=${encodeURIComponent(q)}` : "/encyclopedia");
  };

  return (
    <section className="relative flex min-h-[520px] w-full items-center overflow-hidden md:min-h-[620px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dreamy%20fairy%20tale%20landscape%20with%20glowing%20spirit%20fireflies%20and%20silhouettes%20of%20enchanting%20fairy%20girls%20with%20petals%20and%20stars%2C%20soft%20warm%20cream%20peach%20and%20rose%20pastel%20palette%2C%20ethereal%20glowing%20atmosphere%2C%20romantic%20fantasy%20illustration%2C%20wide%20composition%2C%20high%20quality&width=1600&height=900&seq=hero-bg&orientation=landscape"
          alt="韩国妖精漫画角色图鉴站首屏插画背景"
          title="韩国妖精漫画角色图鉴"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/40 to-background-50"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6 py-16 md:py-24">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50/80 px-3 py-1 text-xs font-medium text-primary-700 backdrop-blur">
            <i className="ri-sparkling-2-fill" aria-hidden="true"></i>
            韩国妖精漫画 · 女主角色图鉴站
          </span>
          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl md:leading-tight">
            韩国妖精漫画<span className="text-primary-600">女主萌娘</span>人设图鉴
          </h1>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            一站式盘点韩国妖精漫画的漂亮女主：颜值与人设、萌娘属性、CP组合、人物关系，全部整理成册。想看哪部作品的角色介绍，从这里直接点进对应作品页即可。
          </p>

          <form onSubmit={submit} className="mt-7 flex max-w-lg flex-col gap-3 sm:flex-row">
            <div className="relative flex-1">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400" aria-hidden="true"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索女主名字、萌娘属性或作品…"
                aria-label="搜索女主、属性或作品"
                className="w-full rounded-full border border-background-200 bg-background-50 py-3 pl-11 pr-4 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200"
              />
            </div>
            <button
              type="submit"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              查角色
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </button>
          </form>

          <div className="mt-7 flex flex-wrap items-center gap-x-6 gap-y-3">
            <Link to="/encyclopedia" className="inline-flex items-center gap-2 text-sm font-medium text-primary-700 hover:text-primary-800">
              <i className="ri-book-2-line" aria-hidden="true"></i>
              进入角色图鉴
            </Link>
            <Link to="/works" className="inline-flex items-center gap-2 text-sm font-medium text-foreground-700 hover:text-foreground-950">
              <i className="ri-film-line" aria-hidden="true"></i>
              浏览作品大全
            </Link>
          </div>

          <dl className="mt-9 flex flex-wrap gap-8">
            <div>
              <dt className="text-xs text-foreground-500">收录角色</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-foreground-950">128+</dd>
            </div>
            <div>
              <dt className="text-xs text-foreground-500">整理作品</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-foreground-950">56+</dd>
            </div>
            <div>
              <dt className="text-xs text-foreground-500">CP组合</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-foreground-950">230+</dd>
            </div>
            <div>
              <dt className="text-xs text-foreground-500">萌娘属性</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-foreground-950">40+</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}